import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import axios from "axios/index";
import {Link} from 'react-router-dom';

import urls from "../../../../../utils/urls";
import {ajaxHandler} from "../../../../../utils/errors";
import {tokenHeader} from "../../../../../utils/headers";
import { Spinner } from '../../../../../components/Loading/Spinner';
import helpers from '../../../../../utils/helpers';
import Accordeon from "../../../../../components/Accordeon/accordeon";
import { reloadTrip } from '../../../../../actions/trip_actions/index';

import DischargeExitControl from './DischargeExitControl';
import DischargePreviousControls from './DischargePreviousControls';
import DischargeMeterSelection from './DischargeMeterSelection';
import DischargeInput from './DischargeInput';
import DischargeDone from './DischargeDone';


class TripDischarge extends Component {

    constructor(props) {
        super(props);

        let {trip} = this.props;

        let finishedDischarges = [];
        let activeDischarge = null;
        let currentDischarge = trip.discharge.length + 1;
        if(trip.discharge && trip.discharge.length > 0){
            // Filter done
            finishedDischarges = trip.discharge.filter(d => d.unload_finished_at);

            // Get first pending
            let pendingDischarge = trip.discharge.find(d => d.unload_finished_at === null);
            if(pendingDischarge){
                activeDischarge = pendingDischarge;
                currentDischarge = trip.discharge.length;
            }
        }

        this.state = {
            canEdit: helpers.canUserDischarge(this.props.user),
            ajaxInProgress: false,
            trip: trip,
            meters: false,
            activeDischarge,
            finishedDischarges,
            currentDischarge,

            // Unload exit control
            showExitControlModal: false
        }
    }

    componentDidMount() {
        this._fetchOptions();
    }

    _initializeHtml = () => {
        window.initializeCollapsible();
    };

    _fetchOptions = () => {
        const METERS_URL = `${urls.API_ROOT}/api/v1/meters/trip/id/${this.state.trip.id}/`;
        axios.get(METERS_URL, tokenHeader())
            .then(response => {
                this.setState({
                    meters: response.data
                }, this._initializeHtml);

            })
            .catch((error) => ajaxHandler(error));
    };

    _updateDischarge = (discharge) => {
        if(discharge && discharge.unload_finished_at){
            // As the discharge is finished, let the user add another
            discharge = null;
        }
        this.setState({activeDischarge: discharge});
    };

    _closeDischarge = () => {
        let TRIP_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.trip.id}/`;
        axios.get(TRIP_URL, tokenHeader())
            .then(response => {
                let trip = response.data;
                if(trip.unload_exit_control === false){
                    this.setState({
                        trip: trip,
                        showExitControlModal: true
                    });
                }else{
                    this._updateCloseDischarge('-');
                }
            })
            .catch(ajaxHandler)
    };

    _updateCloseDischarge = (movements_observations) => {
        let data = {
            next_status: 'D0',
            movements_observations
        };

        const SHIPMENT_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.trip.id}/`;
        axios.put(SHIPMENT_URL, data, tokenHeader())
            .then(this.props.reloadTrip)
            .catch(ajaxHandler)
    };

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        // Waiting for options
        if(!this.state.meters){
            return (
                <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                    <Spinner />
                </div>
            );
        }

        // If there's an ajax call in progress or if user can not edit
        let disableButtons = (this.state.ajaxInProgress || !this.state.canEdit);

        let activeSection = (
            <DischargePreviousControls
                trip={trip} updateDischarge={this._updateDischarge}
                reloadTrip={this.props.reloadTrip}
            />
        );

        if(this.state.activeDischarge) {
            activeSection = (
                <DischargeMeterSelection
                    trip={trip} meters={this.state.meters}
                    discharge={this.state.activeDischarge}
                    updateDischarge={this._updateDischarge}
                />
            );
            if(this.state.activeDischarge.meter){
                activeSection = (
                    <DischargeInput
                        trip={trip} meters={this.state.meters}
                        discharge={this.state.activeDischarge}
                        reloadTrip={this.props.reloadTrip}
                        closeDischarge={this._closeDischarge}
                    />
                );
            }
        }

        if(!this.state.canEdit){
            return (
                <div>
                    <div className={"trip-section"}>
                        <div className={'trip-section-title'}>Descarga</div>
                        <div className={"row no-padding thin-row margin-top-10"}>
                            <div className={"col s12"}>
                                <div className={"waiting-continer valign-wrapper w100"}>
                                    <p className={"w100 center"}>
                                        Esperando la finalización de la descarga
                                        <br />
                                        <i className="material-icons">more_horiz</i>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"row center"}>
                        <div className={"col s12"}>
                            <Link to={'/'} className={`btn btn-shell-empty z-depth-0 text-center`}>
                                Volver
                            </Link>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Descarga</div>
                    <ul className="collapsible no-margin" data-collapsible="accordion">
                        {
                            this.state.finishedDischarges.map((discharge, index) =>{
                                let secondary_text = null;
                                if(discharge.initial_totalizer >= 0 && discharge.final_totalizer >= 0 ){
                                    secondary_text = `Litros: ${discharge.final_totalizer - discharge.initial_totalizer}`
                                }
                                return (
                                    <Accordeon
                                        name={`Descarga ${index + 1}`} key={`discharge-${index}`}
                                        secondary_text={secondary_text}>
                                        <DischargeDone discharge={discharge} />
                                    </Accordeon>
                                )
                            })
                        }
                        <Accordeon active={true} name={`Descarga ${this.state.currentDischarge}`}>
                            {activeSection}
                        </Accordeon>
                    </ul>
                </div>
                {this.state.canEdit && this.state.finishedDischarges.length > 0 && this.state.activeDischarge === null &&
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <Link to={'/'} className={`btn btn-shell-empty z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Volver
                        </Link>
                        <button onClick={this._closeDischarge}
                                className={`btn btn-shell z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Enviar a Balanza Salida
                        </button>
                    </div>
                </div>
                }
                {this.state.showExitControlModal &&
                <DischargeExitControl
                    trip={this.state.trip}
                    afterCloseAction={() => this.setState({showExitControlModal: false})}
                    updateAction={this._updateCloseDischarge}
                />
                }
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({reloadTrip}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TripDischarge);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Discharge/index.js